import React from "react";

export default function CustomButton({ attributes, element, children }) {
  const { buttonText, buttonURL, buttonColor, buttonTextColor, buttonBorderColor, buttonWidth, buttonTargetBlank } =
    element;

  return (
    <div {...attributes}>
      <div
        css={{
          display: "none",
          userSelect: "none",
        }}
      >
        {children}
      </div>
      <div
        css={{
          marginTop: 10,
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
        }}
        contentEditable={false}
      >
        <a
          href={buttonURL}
          target={buttonTargetBlank ? "_blank" : "_self"}
          rel="noreferrer"
          type="button"
          css={{
            margin: 0,
            padding: "5px 15px",
            color: buttonTextColor,
            fontSize: 20,
            letterSpacing: 0.6,
            backgroundColor: buttonColor,
            border: "1px solid",
            borderColor: buttonBorderColor,
            borderRadius: 4,
            minWidth: 200,
            width: buttonWidth ? `${buttonWidth}%` : undefined,
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          {buttonText}
        </a>
      </div>
    </div>
  );
}
